module.exports = new Promise(function (resolve, reject) {
					var __webpack_error__ = new Error()
					if (typeof window["company"] !== 'undefined') return resolve();
					__webpack_require__.l(
						"https://emea.app.company.dev.fcm.travel/remoteEntry.js",
						function (event) {
							if (typeof company !== 'undefined') return resolve();
							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
							var realSrc = event && event.target && event.target.src;
							__webpack_error__.message =
								'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
							__webpack_error__.name = 'ScriptExternalLoadError';
							__webpack_error__.type = errorType;
							__webpack_error__.request = realSrc;
							reject(__webpack_error__);
						},
						"company",
					);
				}).then(function(){
					var proxy = {
						get: function(request) {
							return Promise.resolve().then(function() { return company.get(request); }).then(function(factory) {
								return function() {
									try { return factory(); }
									catch(e) {
										console.warn('remote company factory error for ' + request, e);
										return undefined;
									}
								};
							}).catch(function(e) {
								console.warn('remote company chunk load failed for ' + request, e);
								return function() { return undefined; };
							});
						},
						init: company.init
					}
					return proxy
				}).catch(function(e) {
					console.warn('remote company is not available', e);
					let newProxy = {
						get: (module, scope) => () => undefined,
						init: () => {}
					}
					return(newProxy);
				});